<template>
    <div class="collapsible">
        <div class="collapsible__header" :class="{'collapsible__header_expanded': expanded}" @click="expanded = !expanded">
            {{ title }}
            <div><img src="@/assets/images/expert-panel/down.svg" /></div>
        </div>
        <div ref="body" class="collapsible__body" :class="{'collapsible__body_expanded': expanded}" :style="{height: expanded ? `${height}px` : 0}">
            <div></div>
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "Collapsible",
    props: {
        title: String,
    },
    data() {
        return {
            ro: null,
            height: 0,
            expanded: false,
        };
    },
    methods: {
        resizeObserverCallback() {
            this.height = this.$refs.body.scrollHeight || 0;
        },
    },
    mounted() {
        this.ro = new ResizeObserver(this.resizeObserverCallback);
        this.ro.observe(this.$refs.body);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.collapsible {
  &__header {
    font-weight: 500;
    font-size: rem(16);
    line-height: rem(20);
    color: #131614;
    display: flex;
    align-items: center;
    gap: rem(12);
    cursor: pointer;
    div {
      transition: all 0.3s ease-in-out;
    }
    &_expanded {
      div {
        transform: rotate(180deg);
      }
    }
  }
  &__body {
    padding: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
    div:first-child {
      height: rem(16);
    }
  }
}
</style>